import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { EmptyView, View, withTranslation } from '@piwikpro/ui-components';

const UsersEmpty = withTranslation('administration')(({ t }: any) => (
  <View.Body>
    <EmptyView text={t('users.list.emptyMessage')} />
  </View.Body>
));

export const Route = createFileRoute('/_secured/administration/users/')({
  component: UsersEmpty,
});
